module.exports = __webpack_public_path__ + "img/Freek_stWillies_01.0902bd43.jpg";